import {Animated, Image, Pressable} from "react-native"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, View} from "shared/base"
import React, {useEffect} from "react"
import AnimatedImageBackground from "shared/animated-image-background"
import ClockImage from "./clock.png"
import {Course} from "models"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import RunningManImage from "./running-man.png"

export default memo(shapeComponent(class RoutesUserSchoolClassesClassSpaceCourseCard extends ShapeComponent {
  static propTypes = propTypesExact({
    active: PropTypes.bool.isRequired,
    backgroundImage: PropTypes.string.isRequired,
    course: PropTypes.instanceOf(Course).isRequired,
    onPress: PropTypes.func.isRequired
  })

  firstSetup = true

  smallCourseNameFontSize = 38
  smallWidth = 252
  smallHeight = 284

  largeCourseNameFontSize = 58
  largeWidth = 341
  largeHeight = 413

  courseNameFontSize = new Animated.Value(this.p.active ? 58 : 38)
  width = new Animated.Value(this.p.active ? this.tt.largeWidth : this.tt.smallWidth)
  height = new Animated.Value(this.p.active ? this.tt.largeHeight : this.tt.smallHeight)

  setup() {
    const {firstSetup, largeHeight, largeWidth, smallHeight, smallWidth} = this.tt
    const {active} = this.p

    useEffect(() => {
      if (firstSetup) {
        this.firstSetup = false
      } else {
        let newCourseNameFontSize, newHeight, newWidth

        if (active) {
          newCourseNameFontSize = this.tt.largeCourseNameFontSize
          newWidth = largeWidth
          newHeight = largeHeight
        } else {
          newCourseNameFontSize = this.tt.smallCourseNameFontSize
          newWidth = smallWidth
          newHeight = smallHeight
        }

        Animated.parallel([
          Animated.spring(this.tt.width, {
            toValue: newWidth,
            useNativeDriver: true
          }),
          Animated.spring(this.tt.height, {
            toValue: newHeight,
            useNativeDriver: true
          }),
          Animated.spring(this.tt.courseNameFontSize, {
            toValue: newCourseNameFontSize,
            useNativeDriver: true
          })
        ]).start()
      }
    }, [active])
  }

  render() {
    const {courseNameFontSize, height, width} = this.tt
    const {backgroundImage, course} = this.p
    const courseGroup = course.courseGroups().loaded()[0]
    const actualBackgroundImage = course.backgroundImageUrl() || backgroundImage

    return (
      <Pressable onPress={this.tt.onPress}>
        <AnimatedImageBackground
          imageStyle={this.imageBackgroundImageStyle ||= {borderRadius: 40}}
          source={actualBackgroundImage}
          style={this.imageBackgroundStyle ||= {
            justifyContent: "end",
            width,
            height,
            padding: 40
          }}
        >
          <Text
            style={this.courseNameStyle ||= {
              marginBottom: 24,
              color: "#fff",
              fontFamily: "DreamChaser",
              fontSize: courseNameFontSize,
              fontWeight: 400
            }}
          >
            {course.name()}
          </Text>
          <View style={this.courseTypeContainerStyle ||= {flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
            {courseGroup &&
              <View style={this.courseGroupContainerStyle ||= {flexDirection: "row", alignItems: "center"}}>
                {courseGroup.hasIcon() &&
                  <Icon color="#fff" name={courseGroup.icon()} />
                }
                {!courseGroup.hasIcon() &&
                  <Image source={RunningManImage} style={this.runningManImageStyle ||= {width: 24, height: 24}} />
                }
                <Text style={this.courseTypeTextStyle ||= {marginLeft: 12, color: "#fff", fontSize: 14, fontWeight: 700}}>
                  {courseGroup.name()}
                </Text>
              </View>
            }
            {course.hasEstimatedTime() &&
              <View style={this.estimatedTimeContainerStyle ||= {flexDirection: "row", alignItems: "center"}}>
                <Image source={ClockImage} style={this.clockImageStyle ||= {width: 24, height: 24}} />
                <Text style={this.estimatedTimeTextStyle ||= {marginLeft: 8, color: "#fff", fontSize: 15}}>
                  {course.estimatedTime()}
                </Text>
              </View>
            }
          </View>
        </AnimatedImageBackground>
      </Pressable>
    )
  }

  onPress = () => {
    this.p.onPress({course: this.p.course})
  }
}))
